import { useMutation, useQueryClient } from '@tanstack/react-query'

import { logout } from './auth.service'

export const useLogout = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: logout,
    onSuccess: async () => {
      await queryClient.cancelQueries({ queryKey: ['customerAccountData'] })
      queryClient.removeQueries({ queryKey: ['customerAccountData'], exact: true })
    },
  })
}
